/**
 * 前端验证工具函数
 *
 * 提供表单验证规则和验证函数
 */

/**
 * 验证中国大陆手机号格式
 */
export const validatePhone = (phone: string): boolean => {
  if (!phone) return false
  const pattern = /^1[3-9]\d{9}$/
  return pattern.test(phone)
}

/**
 * 手机号验证规则（用于 antd-mobile Form）
 */
export const phoneRule = {
  pattern: /^1[3-9]\d{9}$/,
  message: '手机号格式不正确'
}

/**
 * 验证日期不能晚于今天
 */
export const validateDateNotFuture = (dateStr: string): boolean => {
  if (!dateStr) return false
  // 验证日期格式 YYYY-MM-DD
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return false

  const parts = dateStr.split('-')
  const inputDate = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]))

  // 检查日期是否有效
  if (isNaN(inputDate.getTime())) return false

  const today = new Date()
  today.setHours(0, 0, 0, 0)
  inputDate.setHours(0, 0, 0, 0)

  return inputDate <= today
}

/**
 * 日期验证规则
 */
export const dateNotFutureRule = {
  validator: (_: any, value: string) => {
    if (!value) return Promise.resolve()
    if (validateDateNotFuture(value)) {
      return Promise.resolve()
    }
    return Promise.reject(new Error('日期不能晚于今天'))
  }
}

/**
 * 验证验证码格式（6位大写字母数字）
 */
export const validateVerificationCode = (code: string): boolean => {
  if (!code) return false
  const pattern = /^[A-Z0-9]{6}$/
  return pattern.test(code)
}

/**
 * 验证码格式规则
 */
export const verificationCodeRule = {
  pattern: /^[A-Z0-9]{6}$/,
  message: '验证码必须是6位大写字母或数字'
}

/**
 * 长度验证规则生成器
 */
export const lengthRule = (min: number, max: number, fieldName: string = '字段') => ({
  min,
  max,
  message: `${fieldName}长度必须在${min}-${max}个字符之间`
})

/**
 * 必填规则生成器
 */
export const requiredRule = (fieldName: string) => ({
  required: true,
  message: `请输入${fieldName}`
})
